import { LeftOutlined } from '@ant-design/icons';
import { Rate } from 'antd';
import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';
import profile from "../assets/profile.png";
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyData } from '../redux/companyDataSlice';

const CompDetails = () => {

    const { admin_id } = useParams();

    const dispatch = useDispatch();

    const { companyData, statusComp, errorComp } = useSelector(
        (state) => state.companyData
    );

    console.log(companyData);

    useEffect(() => {
        dispatch(fetchCompanyData(admin_id));
    }, [dispatch]);

    return (
        <div className="loadingTab all_orders">
            <div className="bg-[#FCFBFA] px-20 max-lg:px-5 py-8">
                <Link to="/" className='flex items-center text-[#283D63] font-semibold'>
                    <LeftOutlined />
                    <p className='ml-3'>Back to home</p>
                </Link>

                <div className="mt-8">
                    <div className="flex items-center">
                        <h2 className="text-[#14294F] font-semibold text-2xl">Company Details</h2>
                    </div>
                </div>

            </div>
            <div className='px-20 max-lg:px-5'>
                <div className="lg:flex items-center my-5">
                    <div>
                        <div className="flex items-center mb-5">
                            <img src={profile} className="w-[48px] mr-3" />
                            <div>
                                <p className="text-[#525D71] font-medium text-lg">{companyData?.admin?.name} {companyData?.admin?.last_name}</p>
                            </div>
                        </div>
                        <Rate allowHalf defaultValue={companyData?.admin?.rates} />
                    </div>
                </div>
                <div className="lg:flex items-center">
                    <p className="text-[#283D63] font-semibold text-lg">
                        Technologies:
                    </p>
                    <div className="flex items-center flex-wrap">
                        {companyData?.used_technologys?.flat().map((tech, index) => (
                            <div
                                key={index}
                                className="text-[#FE9B71] rounded-full font-semibold border-2 border-[#FE9B71] px-5 py-1 mt-5 mb-5 mx-2"
                            >
                                {tech.technology}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="">
                    <p className="text-[#283D63] font-semibold text-lg">
                        Previous works:
                    </p>
                    <div className="grid grid-cols-4 gap-10 max-lg:gap-4 max-xl:grid-cols-1 lg:items-center">
                        {companyData?.prev_works?.flat().map((tech, index) => (
                            <div
                                key={index}
                                className="text-[#FE9B71] rounded-full font-semibold px-5 py-1 mt-5 mb-5 mx-2"
                            >
                                <img
                                    src={`https://service.samoolah.com/${tech?.src}`}
                                    className="w-[80px] mx-auto"
                                />
                                <p className='text-center mt-4'>{tech.project_name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompDetails